<p-button
  [icon]="icon"
  [ngClass]="customClass"
  [rounded]="true"
  severity="warn"
  [text]="true"
  (click)="togglePopover($event)"
></p-button>

@if(isPopoverVisible){
<div
  class="info-popover"
  [ngStyle]="popoverStyle"
  (click)="$event.stopPropagation()"
>
  <div class="info-popover-body">
    <div class="info-text">{{ dialogContent || "Brak informacji" }}</div>
  </div>
</div>
}
